import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class EventRoleService extends BaseService{
	constructor() {
		super('/EventRole');
	}

	public getAllEvent() {
		return super.getAllWithResourceName( 'event');
	}

	public getAllByFilter(filter: EventRoleFilter) {
		return super.getAllByFilterBase(filter);
	}

	public updateEventRole(id: number, eventRole: any) {
		return super.updateBase(this._resourceName + '/update-eventrole/' + id, eventRole);
	}

	public updateEventRoleOneEvent(id: number, idEvent: number, eventRole: any) {
		return super.updateBase(this._resourceName + '/update-eventrole-event/' + id+'/'+idEvent, eventRole);
	}

}

export class EventRoleFilter extends BaseFilter{
	constructor(idEvent?: number | null, idTenant?: number | null) {
		super();
		this._idEvent = idEvent;
		this._idTenant = idTenant;
	}
	
	private _idEvent?: number | null;
	private _idTenant?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idEvent != null ? { IdEvent: this._idEvent } : {})

		);

		return data;
	};
}